(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('TypePatientContactTypes', TypePatientContactTypes);

    TypePatientContactTypes.$inject = ['$resource'];

    function TypePatientContactTypes ($resource) {
        var resourceUrl =  'api/type-patient-contact-types/:id';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'byCorporation': {url: 'api/type-patient-contact-types/by-corporation/:id', method: 'GET', isArray: true}
        });
    }
})();
